/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import CampaignModel, { CampaignState } from 'cio/models/campaign';
import { ExitCondition, selectedExitCondition } from 'cio/utils/campaigns/exit-conditions';

interface CampaignsExitSummaryArgs {
  campaign: CampaignModel;
}

export default class CampaignsExitSummary extends Component<CampaignsExitSummaryArgs> {
  readonly ExitCondition = ExitCondition;
  readonly CampaignState = CampaignState;

  @tracked selectedExitCondition: ExitCondition | null = null;

  @computed('args.campaign.conversionAction')
  get campaignConversionActionInPastTense(): string {
    let { conversionAction } = this.args.campaign;

    // eslint-disable-next-line spellcheck/spell-checker
    if (conversionAction.slice(-3) === 'ing') {
      return `${conversionAction.slice(0, -3)}ed`;
    }

    return conversionAction;
  }

  @action
  setSelectedExitCondition() {
    this.selectedExitCondition = selectedExitCondition(this.args.campaign);
  }
}
